export const ACTOR = '[ACTOR]'
export const ADD_ACTORS = `${ACTOR} Add Actors`
export const DELETE_ACTORS = `${ACTOR} Delete Actors`
export const UPDATE_ACTORS = `${ACTOR} Update Actors`
export const DELAY_ACTOR = `${ACTOR} Delay Actor's next action`
export const RESET_ACTORS_DELAY = `${ACTOR} Reset all Actors' delay`
export const RESET_ACTORS = `${ACTOR} Reset Actors State`

export const addActors = actors => ({
    type: ADD_ACTORS,
    payload: {
        actors,
    },
})

export const deleteActors = targets => ({
    type: DELETE_ACTORS,
    payload: {
        targets,
    },
    meta: {
        battleStage: 'check',
    },
})

export const updateActors = action => ({
    type: UPDATE_ACTORS,
    payload: {
        target: action.target,
        changedStatus: action.changedStatus,
    },
    meta: {
        processBattle: 'check',
    },
})

export const delayActor = (target, delay) => ({
    type: DELAY_ACTOR,
    payload: {
        target,
        delay,
    },
})

export const resetActorsDelay = () => ({
    type: RESET_ACTORS_DELAY,
    payload: {},
})

export const resetActors = () => ({
    type: RESET_ACTORS,
    payload: {},
})
